<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="vatFilter === 'all'"
            variant="outline-secondary"
            @click="updateVatFilter('all')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="vatFilter === 'M'"
            variant="outline-primary"
            @click="updateVatFilter('M')"
        >
            M
        </b-button>
        <b-button
            :pressed="vatFilter === 'T'"
            variant="outline-primary"
            @click="updateVatFilter('T')"
        >
            T
        </b-button>
        <b-button
            :pressed="vatFilter === 'A'"
            variant="outline-primary"
            @click="updateVatFilter('A')"
        >
            A
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'VatFilter',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            vatFilter: (state) => state.browsing.vatFilter,
        }),
    },

    methods: {
        updateVatFilter(value) {
            this.$store.commit('browsing/SET_VAT_FILTER', value)
            this.$root.$refs.vatTable.filterItems()
        },
    },
}
</script>

<style scoped></style>
